import React, {PureComponent} from 'react';
import {compose} from 'redux';
import {
    Typography, withStyles, //Card, CardContent, CardActions, Button
} from "@material-ui/core";

const styles = theme => ({
    root: {

    },
    bullets: {
        marginTop: theme.spacing.unit/2,

        '& li:not(:first-child)': {
            marginTop: theme.spacing.unit,
        }
    },
    caption: {
        marginTop: theme.spacing.unit,
    },
    card: {
        margin: theme.spacing.unit*2,
    },
    actions: {
        display: 'flex',
        justifyContent: 'flex-end',
    }
});

class RegisterPush extends PureComponent {
    render() {
        const {classes} = this.props;

        return (
            <React.Fragment>
                {/*<Card className={classes.card}>
                    <CardContent>
                        <Typography variant="body1" style={{color: '#000000'}}>
                            wifi.pantanova.se vill skicka notifikationer till dig
                        </Typography>
                    </CardContent>
                    <CardActions className={classes.actions}>
                        <Button size="small" color="primary">Block</Button>
                        <Button size="small" color="primary">Allow</Button>
                    </CardActions>
                </Card>*/}
                <Typography variant="title" paragraph>
                    Tillåt notiser för att aktivera internet
                </Typography>
                <Typography variant="body1">
                    Hur funkar det?
                </Typography>
                <Typography variant="body2" paragraph component="span">
                    <ul className={classes.bullets}>
                        <li>Fri tillgång till internet</li>
                        <li>Attraktiva erbjudanden när någon slänger skräp i din närhet</li>
                        <li>Erbjudanden skickas enbart när du är uppkopplad på något av våra WiFi</li>
                    </ul>
                </Typography>
            </React.Fragment>
        );
    }
}

export default compose(
    withStyles(styles, {withTheme: true}),
)(RegisterPush);



// WEBPACK FOOTER //
// ./src/containers/Register/Push.js